import toastr from "toastr";
import user from "./user";
import { ask, promptPassword } from "../plugins/dialogs";
let onTokenExchanged = new Event("onTokenExchanged");

//Handles OAuth2 tokens
export class apiToken {
  constructor(grant_type = "client_credentials") {
    this.grant_type = grant_type;
    this.storageItemName = `tk_${this.grant_type}`;
    this.pending = false;
    this.tk = {};
  }

  goingToExpire = () => {
    this.load();

    if (!this.tk?.valid_till) return false;

    let dateTo = new Date(this.tk.valid_till);
    let dateNow = new Date();

    if (Date.now() > this.tk.valid_till - api.tokenExpireGapMin * 1000 * 60) {
      if (api.debug)
        console.log(
          `%c Token: Going to expire? now:${dateNow.toLocaleString()} to:${dateTo.toLocaleString()} YES`,
          "color: purple"
        );
      return true;
    }
    if (api.debug)
      console.log(
        `%c Token: Going to expire? now:${dateNow.toLocaleString()} to:${dateTo.toLocaleString()} NO`,
        "color: purple"
      );
    return false;
  };

  init = async () => {
    this.load(); //Loads token from local storage if exists
    this.parse(); //then checks if got token in hash to parse and update
    this.valid = false;

    if (!this.tk.access_token) {
      if (this.grant_type === "client_credentials") {
        await this.new(); //Retrieve new app token if in such mode
      } else {
        //We have no token at all at can't retrieve
        console.error("No Token available");
      }
    } else {
      if (Date.now() > this.tk.valid_till) {
        if (this.tk.refresh_token) {
          await this.refresh();
        } else {
          if (this.grant_type === "client_credentials") {
            await this.new(); //Retrieve new app token if in such mode
          } else {
            //Token expirend & no key to refresh
            console.error("Token has expired and no refresh_token available");
          }
        }
      } else {
        //We are fine
        this.valid = true;
      }
    }
  };

  flush = () => localStorage.removeItem(this.storageItemName);

  load = () =>
    (this.tk = JSON.parse(localStorage.getItem(this.storageItemName)) || {});

  parse = () => {
    const params = new URLSearchParams(document.location.hash.substr(1));
    if (params.get("access_token")) {
      this.set(
        params.get("access_token"),
        decodeURIComponent(params.get("refresh_token")),
        params.get("expires_in"),
        params.get("session")
      );
      if (api.debug)
        console.log(
          `%c Token ${this.grant_type} PARSED from hash`,
          "color: purple"
        );

      if (api.debug)
        console.log("http://localhost:3000/" + document.location.hash);
      document.location.hash = "#";
    }
  };

  save = () =>
    localStorage.setItem(this.storageItemName, JSON.stringify(this.tk));

  new = async () => {
    if (api.debug) console.log("%c Token: NEW asked", "color: green");
    await this.fetch({
      client_id: api.clientId,
      grant_type: this.grant_type,
      scope: api.scope,
    });
  };

  refresh = async () => {
    if (api.debug) console.log("%c Token: REFRESH asked", "color: purple");
    await this.fetch({
      refresh_token: this.tk.refresh_token,
      grant_type: "refresh_token",
    });
  };

  exchange = async () => {
    if (api.debug) console.log("%c Token: EXCAHNGE asked", "color: purple");

    //Check for stored tk, it may has changed...
    let storedTk = JSON.parse(localStorage.getItem(this.storageItemName)) || {};

    if (
      storedTk.access_token &&
      storedTk.access_token !== this.tk.access_token &&
      storedTk.valid_till > this.tk.valid_till
    ) {
      if (Date.now() < this.tk.valid_till) {
        if (api.debug)
          console.log("%c Token: FOUND NEWER in storage", "color: purple");
        this.load();
        return;
      }
    }

    await this.fetch({
      subject_token: this.tk.access_token,
      subject_token_type: "urn:ietf:params:oauth:token-type:access_token",
      client_id: api.clientId,
      grant_type: "urn:ietf:params:oauth:grant-type:token-exchange",
    });
    document.dispatchEvent(onTokenExchanged);
  };

  fetch = async (body) => {
    if (this.pending) {
      if (api.debug)
        console.log("%c Token: Pending...can't fetch again", "color: purple");
      return;
    }
    this.pending = true;
    if (api.debug)
      console.log(
        "%c Token: FETCH body " + JSON.stringify(body),
        "color: purple"
      );
    let response = await fetch(`${api.domain}/oauth2/token`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      mode: "cors",
      cache: "no-store",
      credentials: "omit",
    });
    let json = await response.json();
    this.pending = false;
    if (response.ok) {
      if (api.debug) console.log("%c Token: fetch SUCCESS", "color: purple");
      this.set(json["access_token"], json["refresh_token"], json["expires_in"]);
      return true;
    } else {
      if (api.debug)
        console.log(
          "%c Token: fetch FAILED: " + JSON.stringify(json),
          "color: purple"
        );
      this.flush();
      return false;
    }
  };

  set = (access, refresh, expires, sessionId = false) => {
    let expires_in = parseInt(expires) || 0;
    let session = sessionId || this.tk.session;
    this.tk = {
      access_token: access && access !== "null" ? access : "",
      refresh_token: refresh && refresh !== "null" ? refresh : "",
      valid_till: Date.now() + expires_in * 1000,
      session,
    };
    this.save();
  };
}

//Handles API connections
export const api = {
  debug: true,
  toasts: false,
  domain: window.appConfig.domain,
  path: "/api/v1",
  clientId: "web-ship-safety.ru",
  scope: window.appConfig.scope || "api",
  cached: {},
  token: new apiToken("user"),
  tokenExpireGapMin: 20,
  tokenCheckInterval: 1000 * 60 * (1 + Math.random()),
  apiCheckInterval: 5000,

  nullUuid: "00000000-0000-4000-8000-000000000000",
  minDate: "1970-01-01 00:00:00",
  maxDate: "4433-12-31 00:00:00",

  q: async (
    path = "",
    body = {},
    headers = {},
    method = "POST",
    quiet = !api.debug
  ) => {
    let result = await api.tfetch(path, body, headers, method).then(
      (json) => {
        if (json.hasOwnProperty("error")) {
          if (!quiet) toastr.warning(json.error["message"]);
          return false;
        } else {
          return json;
        }
      },
      (e) => {
        if (!quiet) toastr.warning(e.message);
        return false;
      }
    );
    return result;
  },

  qo: async (
    path = "",
    body = {},
    keyField = "id",
    headers = {},
    method = "POST",
    quiet = !api.debug
  ) => {
    let result = await api.tfetch(path, body, headers, method).then(
      (json) => {
        if (json.hasOwnProperty("error")) {
          if (!quiet) toastr.warning(json.error["message"]);
          return {};
        } else {
          let items = {};
          json = Array.isArray(json) ? json : [json];

          json.forEach((item, index) => {
            let key = item[keyField] || index;
            items[key] = item;
          });

          return items;
        }
      },
      (e) => {
        if (!quiet) toastr.warning(e.message);
        return {};
      }
    );
    return result;
  },

  qac: async function () {
    let key = "_qac_" + JSON.stringify(arguments);
    if (!api[key]) {
      api[key] = await api.qa(...arguments);
    }
    return api[key];
  },

  qa: async (
    path = "",
    body = {},
    keyField = "id",
    headers = {},
    method = "POST",
    quiet = !api.debug
  ) => {
    let result = await api.tfetch(path, body, headers, method).then(
      (json) => {
        if (json.hasOwnProperty("error")) {
          if (!quiet) toastr.warning(json.error["message"]);
          return [];
        } else {
          let items = [];
          if (Array.isArray(json)) {
            items = json;
          } else {
            if (Object.keys(json)?.length) {
              items = [json];
            }
          }
          return items;
        }
      },
      (e) => {
        if (!quiet) toastr.warning(e.message);
        return [];
      }
    );
    return result;
  },

  qrc: async function () {
    let key = "_qrc_" + JSON.stringify(arguments);
    if (!api[key]) {
      api[key] = await api.qr(...arguments);
    }
    return api[key];
  },

  qr: async (
    path = "",
    forceType = false,
    labelField = "label",
    addEmpty = false,
    headers = {},
    bodyParams = {},
    method = "POST",
    quiet = !api.debug
  ) => {
    let search = [
      {
        field: "statetypecode",
        compare: "EQL",
        value: "enabled",
      },
    ];

    if (forceType) {
      search.push({
        field: "typecode",
        compare: "EQL",
        value: forceType,
      });
    }
    let body = {
      search,
      reclimit: 0,
      fields: ["id", labelField],
      ...bodyParams,
    };

    let result = await api.tfetch(path, body, headers, method).then(
      (json) => {
        if (json.hasOwnProperty("error")) {
          if (!quiet) toastr.warning(json.error["message"]);
          return [];
        } else {
          let items = [];
          items = Array.isArray(json) ? json : [json];

          let result = [];

          if (addEmpty) {
            result.push(addEmpty);
          }

          items.forEach((item) => {
            result.push({
              value: item.id,
              label: item[labelField],
            });
          });

          return result;
        }
      },
      (e) => {
        if (!quiet) toastr.warning(e.message);
        return [];
      }
    );
    return result;
  },

  qoo: async (
    path = "",
    body = {},
    headers = {},
    method = "POST",
    quiet = !api.debug,
    parentKey = "parent",
    sortBy = false
  ) => {
    let result = await api.tfetch(path, body, headers, method).then(
      (json) => {
        if (json.hasOwnProperty("error")) {
          if (!quiet) toastr.warning(json.error["message"]);
          return {};
        } else {
          let itemsOrdered = {};
          let items = {};
          let itemsIDs = [];

          if (json["id"]) json = [json];
          if (Array.isArray(json)) {
            if (sortBy) {
              json.sort((a, b) => {
                return a[sortBy] - b[sortBy];
              });
            }

            json.forEach((item) => {
              itemsIDs.push(item.id);
            });

            json.forEach((item) => {
              if (!item[parentKey] || !itemsIDs.includes(item[parentKey])) {
                itemsOrdered[`_${item.id}`] = {
                  ...item,
                  level: 0,
                  structureLevel: 0,
                };
                itemsOrdered = Object.assign(
                  itemsOrdered,
                  api.getChildren(json, item.id, 1, parentKey)
                );
              }
            });
          }
          return itemsOrdered;
        }
      },
      (e) => {
        if (!quiet) toastr.warning(e.message);
        return {};
      }
    );
    return result;
  },

  getChildren: (items, seekId, level, parentKey = "parent") => {
    let children = {};

    items.forEach((item) => {
      if (item[parentKey] === seekId) {
        children[`_${item.id}`] = { ...item, level, structureLevel: level };
        children = Object.assign(
          children,
          api.getChildren(items, item.id, level + 1, parentKey)
        );
      }
    });
    return children;
  },

  tokenFailedHandle: async () => {
    let username = user.info?.profile?.username;
    if (user.isAuthorized && username) {
      let authSuccess = false;
      let cancell = false;
      while (!authSuccess && !cancell) {
        let promptResult = await promptPassword(
          "<div><div class='small text-muted mb-4'>Ваш маркер досутпа истек.</div> Введите пароль, если хотите продолжить работу.</div>"
        );
        let password = promptResult.value;
        if (password) {
          authSuccess = await api.token.fetch({
            grant_type: "password",
            username,
            password,
          });
          if (!authSuccess) {
            let proceed = await ask(
              "Не удается авторизоваться с помощью пароля. Попробовать еще раз?",
              "Ошибка",
              "question"
            );
            if (!proceed.value) {
              cancell = true;
            }
          }
        } else {
          cancell = true;
        }
      }

      if (!authSuccess) {
        document.location.replace(window.appConfig.authUrl);
      } else {
        return true;
      }
    } else {
      return false;
    }
  },

  tfetch: async (
    path = "",
    body = {},
    headers = {},
    method = "POST",
    token = false
  ) => {
    await api.token.init(); //init token

    let fetchHeaders = new Headers(headers);
    fetchHeaders.append("Content-Type", "application/json");

    if (path === "/flush") {
      api.token.flush();
    }

    if (!api.token.valid) {
      let tokenRetryResult = await api.tokenFailedHandle();
      if (!tokenRetryResult) {
        if (api.toasts)
          toastr.warning(
            `Token is not present or has expired`,
            `API error: apiToken`
          );

        throw new Error(`Authorization error`);
      }
    }

    fetchHeaders.append("Authorization", `Bearer ${api.token.tk.access_token}`);
    return api.fetch(path, body, fetchHeaders, method);
  },

  fetch: async (path = "", body = null, headers = {}, method = "POST") => {
    const url = `${api.domain}${api.path}${path}`;
    if (api.debug) {
      console.log("--> API ", path, JSON.stringify(body), headers);
    }
    let response = await fetch(url, {
      method: method,
      headers: headers,
      body: JSON.stringify(body),
      mode: "cors",
      cache: "no-store",
    });
    let json = await response.json();
    if (api.debug) console.log(`API <-- ${path}`, json);

    if (json) {
      if (json.error && api.toasts)
        toastr.warning(
          json.error.message,
          `API error (HTTP ${response.status})`
        );

      let errMessage = "";
      if (json.error) errMessage = json.error["message"] || "";

      if (response.status === 403) {
        api.tokenFailedHandle();
      }
      if (response.status === 401) {
        //unauthorized
        throw new Error(`401  ${errMessage}`);
      }
      if (response.status === 400) {
        //Invalid token
        throw new Error(`400  ${errMessage}`);
      }

      return json;
    } else {
      //No valid json, whatta fuck?!
      throw new Error(`API Server did not respond correctly`);
    }
  },

  JSONdecode: (json) => {
    let data = false;
    try {
      data = JSON.parse(json);
    } catch (e) {
      if (api.debug) toastr.warning(e.message);
    }
    return data;
  },

  cache: async (resourceId, resourceFn, resourceFnParams = {}) => {
    let resourceKey = resourceId.replace(/\//gi, "");
    if (api.cached[resourceKey]) return api.cached[resourceKey];
    api.cached[resourceKey] = await resourceFn(resourceId, resourceFnParams);
    return api.cached[resourceKey];
  },

  checkToken: () => {
    if (api.token) {
      if (api.token.goingToExpire()) {
        api.token.exchange();
      }
    }
  },

  getReferenceValue: (value, reference) => {
    if (Array.isArray(reference)) {
      if (Array.isArray(value)) {
        return reference.filter((item) => value.includes(item.value));
      } else {
        return reference.find((item) => item.value === value) || null;
      }
    }
    return {};
  },

  filterOption: (option, inputValue) => {
    let reg = new RegExp(inputValue, "gi");
    return (option.label.toString().match(reg) || []).length > 0;
  },

  getDateInputValue: (v) => {
    if (v) {
      return new Date(v);
    }
    return "";
  },

  regexEscape: (string) => {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  },

  toBase64: (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const readerResult = reader.result;
        const resultString = readerResult.toString();
        const re = /^data:(.*,)?/;
        let mimeRe = resultString.match(re);
        let type = mimeRe[0];

        let encoded = resultString.replace(re, "");
        if (encoded.length % 4 > 0) {
          encoded += "=".repeat(4 - (encoded.length % 4));
        }
        if (api.debug) {
          console.log("-- FILE: readed", file);
        }
        resolve({ encoded, type, readerResult, resultString });
      };
      reader.onerror = (error) => reject(error);
    }),

  lastCallCache: [],
};

//WebSocket
export class ws extends WebSocket {
  constructor(reconnectFn = false) {
    api.token.load();
    api.token.parse();

    super(window.appConfig.wsDomain + "/session/" + api.token.tk.session);
    this.reconnectFn = reconnectFn;
  }

  onopen = () => {
    this.isAuthorized = false;
    this.log("Open");
    this.auth();
    document.addEventListener("onTokenExchanged", () => {
      this.auth();
    });
  };

  auth = async () => {
    const byToken = true;
    await api.token.init();
    let p = {};
    if (byToken) {
      p = {
        token: api.token.tk.access_token,
      };
    } else {
      p = {
        session: api.token.session,
        secret: api.token.secret,
      };
    }
    this.sq({ u: "001", t: 0, p });
  };

  subscribe = async () => {
    this.sq({
      a: "/observer/subscribe",
      p: [
        {
          publisher: "notify",
          filter: {
            classes: ["task"],
          },
          params: {
            type: "object",
          },
        },
        {
          publisher: "notice",
          params: {
            type: "notify",
          },
        },
        {
          publisher: "ai",
          params: {
            type: "notify",
          },
        },
      ],
    });
  };

  onclose = (event) => {
    //event.wasClean
    //event.code
    //event.reason

    this.log("Closed", event);
    if (this.reconnectFn) {
      this.reconnectFn();
    }
  };

  sq = (params) => {
    let messageDefauls = { t: "2", u: "001" };
    let message = Object.assign(messageDefauls, params);
    if (params.a) message.a = params.a;
    if (params.p) message.p = params.p;

    this.log(" ==>  ", message);
    this.log(" MESSAGE ", JSON.stringify(message));
    this.send(JSON.stringify(message));
  };

  q = (path, payload = null) => {
    this.sq({ t: "2", a: path, p: payload });
  };

  onmessage = (event) => {
    let responce = {};
    let responceReaded = false;
    try {
      responce = JSON.parse(event.data);
      responceReaded = true;
    } catch (e) {
      this.log(" <== JSON ERROR ", e);
      this.log(" <== RAW EVENT ", event);
    }
    if (responceReaded) {
      let payload = responce.p || {};
      switch (responce.t) {
        case 4:
          this.log(" <== API ERROR", responce);
          break;
        case 3:
          if (payload.authorized) {
            this.isAuthorized = true;
            this.userid = payload.userid;
            this.subscribe();
          }
          this.log(" <== ", responce);
          break;
        case 2:
          this.log(" <== NOTIFY ", responce);
          if (payload.id) {
            document.dispatchEvent(
              new CustomEvent("onWSNotification", {
                detail: { payload, userid: this.userid },
              })
            );
          }
          break;
        default:
          this.log("Unknown responce type", responce);
      }
    }
  };

  onerror = (error) => {
    this.log(" WS ERROR ", error);
  };

  log = (m = "", o = "") => {
    if (api.debug) {
      console.log("WS:", m, o);
    }
  };
}

//Cart
export class cart {
  constructor() {
    this.cartCount = 0;
    this.cartItems = [];
  }
  addItem = async (id) => {
    await this.checkCart();
    let result = await api.q("/object/group/member/add", {
      code: "cart",
      object: id,
    });
    await this.load();
    return result;
  };
  deleteItem = async (id) => {
    await api.q("/object/group/member/delete", {
      code: "cart",
      object: id,
    });
    await this.load();
  };
  deleteItems = async (ids) => {
    if (Array.isArray(ids)) {
      let request = [];
      ids.forEach((id) => {
        request.push({ code: "cart", object: id });
      });
      await api.q("/object/group/member/delete", request);
      await this.load();
    }
  };
  checkCart = async () => {
    let result = await api.q("/object/group/get", {
      code: "cart",
    });
    if (result) {
      if (result.code) {
        return;
      } else {
        await api.q("/object/group/set", { code: "cart", name: "Подборка" });
      }
    }
  };
  load = async () => {
    let cartItems = await api.qa("/object/group/member", {
      code: "cart",
    });
    if (cartItems) {
      if (cartItems[0]) {
        if (cartItems[0].id) {
          this.cartItems = cartItems;
          this.cartCount = this.cartItems.length;
          await this.loadItemsData();
          return;
        }
      }
    }
    this.cartItems = [];
    this.cartCount = 0;
  };
  loadItemsData = async () => {
    let queryParams = [];
    this.cartItems.forEach((item) => {
      if (item.classcode === "product") {
        queryParams.push({
          key: item.id,
          path: "/api/v1/product/get",
          payload: {
            id: item.id,
          },
        });
      }
    });

    let cartItemsData = {};
    if (queryParams.length > 0) {
      let result = await api.qa("/run", queryParams);
      if (result && Array.isArray(result)) {
        result.forEach((resultItem) => {
          if (resultItem.payload) {
            let payload = resultItem.payload[0] || {};
            if (payload.id) {
              cartItemsData[payload.id] = payload;
            }
          }
        });
      }
    }
    this.cartItemsData = cartItemsData;
  };
}

//Favorites
export class fav {
  constructor() {
    this.favCount = 0;
    this.favItems = [];
  }
  getItem = (id) => {
    return this.favItems.find((item) => item.id === id) || {};
  };
  addItem = async (id) => {
    await this.check();
    let result = await api.q("/object/group/member/add", {
      code: "favorites",
      object: id,
    });
    await this.load();
    return result;
  };
  deleteItem = async (id) => {
    await api.q("/object/group/member/delete", {
      code: "favorites",
      object: id,
    });
    await this.load();
  };
  deleteItems = async (ids) => {
    if (Array.isArray(ids)) {
      let request = [];
      ids.forEach((id) => {
        request.push({ code: "favorites", object: id });
      });
      await api.q("/object/group/member/delete", request);
      await this.load();
    }
  };
  check = async () => {
    let result = await api.q("/object/group/get", {
      code: "favorites",
    });
    if (result) {
      if (result.code) {
        return;
      } else {
        await api.q("/object/group/set", {
          code: "favorites",
          name: "Избранное",
        });
      }
    }
  };
  load = async () => {
    let items = await api.qa("/object/group/member", {
      code: "favorites",
    });
    if (items) {
      if (items[0]) {
        if (items[0].id) {
          this.favItems = items;
          this.favCount = this.favItems.length;
          return;
        }
      }
    }
    this.favItems = [];
    this.favCount = 0;
  };
}

setInterval(api.checkToken, api.tokenCheckInterval);
